import {
  afterNextRender,
  Directive,
  ElementRef,
  inject,
  input,
  type OnDestroy,
  output,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- The directive is used as an attribute selector, which is a valid use case.
  selector: '[homefinderInViewport]',
})
export class InViewportDirective implements OnDestroy {
  private readonly _elementRef = inject(ElementRef);

  public readonly threshold = input<number>(0);
  public readonly visibilityChange = output<boolean>();

  private _observer?: IntersectionObserver;

  constructor() {
    afterNextRender(() => {
      const _options = {
        root: null,
        rootMargin: '0px',
        threshold: this.threshold(),
      };

      this._observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.visibilityChange.emit(entry.isIntersecting);
        });
      }, _options);

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- The nativeElement is of type any, which is compatible with the IntersectionObserver API.
      this._observer.observe(this._elementRef.nativeElement);
    });
  }

  public ngOnDestroy(): void {
    if (this._observer) {
      this._observer.disconnect();
    }
  }
}
